import { defineComponent as _defineComponent } from 'vue'
import { Offer } from '@/@types/graphql-types';
import NewDesignModal from '@/components/modals/vfm/NewDesignModal.vue';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { computed, defineAsyncComponent } from 'vue';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { isProWebCountry } from '@/helpers/pro-web-helper';
import { useMounted } from '@vueuse/core';
import Spinner from '@/ui-components/Spinner.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'JwTVModal',
  props: {
    offer: null,
    title: { default: undefined },
    additionalContexts: null
  },
  setup(__props: any) {

const props = __props as { offer: Offer, title: TitleDetail, additionalContexts?: SnowplowContext[] };

const JWTVAvodPlayer = defineAsyncComponent({
	loader: () =>
		import(/* webpackChunkName: "jwtv-avod-player" */ '@/features/jwtv-avod/components/JWTVAvodPlayer.vue'),
	loadingComponent: Spinner,
});
const JWTVProFooter = () => import('@/pages/titleDetailV1/v1/hero/JWTVProFooter.vue');


const { isPremium } = storeToRefs(useUserStore());
const { webLocale } = storeToRefs(useLanguageStore());
const isMounted = useMounted();

const showJWTVProFooter = computed(() => {
	return !isPremium.value && isProWebCountry(webLocale.value);
});

const titleName = computed(() =>
	props.title?.__typename == 'Season' ? props.title?.show?.content.title : props.title?.content.title
);

const clip = computed(() => ({
	provider: 'JUSTWATCH_TV',
	externalId: props.offer.id,
	sourceUrl: props.offer.streamUrlExternalPlayer ?? props.offer.streamUrl,
}));

return { __sfc: true,JWTVAvodPlayer, JWTVProFooter, props, isPremium, webLocale, isMounted, showJWTVProFooter, titleName, clip, NewDesignModal }
}

})